/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {ValidationModel} from './validation.model';

export type PowerType = 'ICE' | 'EV';

export const POWER_TYPES: PowerType[] = ['ICE', 'EV'];

export class AggregatorSignalRow extends ValidationModel {
  id?: number;
  objectCode: string;
  architecture?: string;
  keyword?: string;
  powerType: PowerType;
  connector: string;
  connectorPin: string;
  portSignalName: string;
  fkTerminalSizeId?: number | null;
  // Display/edit value for the minimum terminal size. Derived from fkTerminalSizeId via the
  // terminal-size lookup so the grid and Excel report show the size (e.g. "0.5"), not the raw id.
  // Kept in sync with fkTerminalSizeId (which is what the backend persists).
  terminalSize?: string;
  swChannelId: string;
  fkIoTypeDesignatorId?: number | null;
  // Display/edit value for the IO type. Derived from fkIoTypeDesignatorId via the designator
  // lookup so the grid and Excel report show the designator (e.g. "ETH"), not the raw id.
  // Kept in sync with fkIoTypeDesignatorId (which is what the backend persists).
  ioTypeDesignator?: string;
  partNumber: string;
  pwmGroup?: string;
  vRefMapping?: string;
  // Stored as ICD YesOrNo acro Y/N; the grid formats Yes/No for display.
  flexibleDiscreteOutputs?: string;
  fkPlatingId?: number | null;
  // Display/edit value for terminal plating. Derived from fkPlatingId via the plating lookup
  // so the grid shows Sn/Ag/Au. Kept in sync with fkPlatingId (which is what the backend persists).
  terminalPlating?: string;
  // state, changes, originalRowData, fieldRules and rowNumber are inherited from
  // GridModel/ValidationModel (see io-matrix.models.ts IoMatrixRow for the same pattern).
}

/** ICD pin Frequency Group / VRef Mapping dropdown row from {@code DbEnum.buildAcroStatusList}. */
export interface EioEnumOption {
  acro: string;
  status: string;
}

export interface AggregatorSignalKey {
  objectCode: string;
  architecture: string;
  powerType: string;
  keyword?: string;
  rowCount: number;
}

export interface IoTypeDesignatorOption {
  id: number;
  ioTypeDesignator: string;
}

export interface TerminalSizeOption {
  id: number;
  size: string;
}

export interface PlatingOption {
  id: number;
  plating: string;
}
